import { useEffect, useState } from "react";

/**
 * Trail a rapidly-changing value by `delay` ms.
 *
 * Used to keep a search box from firing a request per keystroke — the board
 * search hits the API, so "robotics" would otherwise be eight round trips and
 * seven wasted renders.
 */
export function useDebouncedValue<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
